var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7969 5.06755H1.98843L5.36991 1.68607C5.56518 1.49081 5.56518 1.17423 5.36991 0.978966C5.17465 0.783704 4.85807 0.783704 4.66281 0.978966L0.447303 5.19447C0.373086 5.26869 0.327078 5.36043 0.309279 5.45638C0.301161 5.49213 0.296875 5.52934 0.296875 5.56755C0.296875 5.56954 0.296887 5.57153 0.29691 5.57352C0.295404 5.70341 0.344207 5.83379 0.443322 5.9329L4.66234 10.1519C4.85761 10.3472 5.17419 10.3472 5.36945 10.1519C5.56471 9.95666 5.56471 9.64008 5.36945 9.44482L1.99219 6.06755H11.7969C12.073 6.06755 12.2969 5.8437 12.2969 5.56755C12.2969 5.29141 12.073 5.06755 11.7969 5.06755Z",
    fill: "#0D8390"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.b439f69eac117e753ad6e3a039b08ddc.svg";
export { ForwardRef as ReactComponent };